import { render, staticRenderFns } from "./ConstructManageDetail.vue?vue&type=template&id=6280fb74&scoped=true&"
import script from "./ConstructManageDetail.vue?vue&type=script&lang=js&"
export * from "./ConstructManageDetail.vue?vue&type=script&lang=js&"
import style0 from "./ConstructManageDetail.vue?vue&type=style&index=0&id=6280fb74&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6280fb74",
  null
  
)

export default component.exports